import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { SCROLL_OFFSET } from '../utilities/WordpressConstants';

export const scrollToHashElement = (hash: string, offset: number = 0) => {
  if (!hash) {
    return;
  }
  const element = document.getElementById(hash.replace('#', ''));
  if (element) {
    window.scrollTo(0, element.offsetTop - offset);
  }
};

export const useScroll = () => {
  const location = useLocation();

  const scrollToHash = useCallback(() => {
    scrollToHashElement(location.hash, SCROLL_OFFSET);
  }, [location.hash]);

  return { scrollToHash };
};
